import { Chart } from '@frontend/chart/types';

export const VENDING_PACKAGE_VOLUME_BY_USER_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'Anna Vermeulen', data: [{ label: 'full_period', value: 86 }] },
        { name: 'Thomas De Smet', data: [{ label: 'full_period', value: 72 }] },
        { name: 'Sarah Peeters', data: [{ label: 'full_period', value: 58 }] },
        { name: 'Lucas Janssens', data: [{ label: 'full_period', value: 45 }] },
        { name: 'Emma Claes', data: [{ label: 'full_period', value: 39 }] },
        { name: 'Noah Wouters', data: [{ label: 'full_period', value: 28 }] },
        { name: 'Julie Maes', data: [{ label: 'full_period', value: 15 }] }
    ]
};
